export default __webpack_public_path__ + "static/media/email-inbox-gray.518bfdba.svg";